import React from 'react'
import { mdiCheckCircleOutline } from '@mdi/js'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'

import { successPageMessages } from './messages'
import {
  BackToLoginWrapper,
  StyledDescriptionText,
  SuccessIcon,
  SuccessIconContainer,
} from './styles'
import CommonButton from 'components/Button/CommonButton'
import LoginCommonLayout from '../../LoginCommonLayout'
import { StyledAuthForm } from 'features/auth/login/styles'
import { StyledMainHeading } from './../../MainHeading/MainHeading'

const InitSuccessPage: React.FC = () => {
  const { formatMessage } = useIntl()
  const history = useHistory()
  return (
    <LoginCommonLayout>
      <StyledAuthForm as="div">
        <SuccessIconContainer>
          <SuccessIcon path={mdiCheckCircleOutline} size={3} />
        </SuccessIconContainer>
        <StyledMainHeading>
          {formatMessage(successPageMessages.title)}
        </StyledMainHeading>
        <StyledDescriptionText>
          {formatMessage(successPageMessages.description)}
        </StyledDescriptionText>
        <BackToLoginWrapper>
          <CommonButton
            type="button"
            variant="goldenOutlined"
            onClick={() => history.push('/')}
          >
            {formatMessage(successPageMessages.goToLogin)}
          </CommonButton>
        </BackToLoginWrapper>
      </StyledAuthForm>
    </LoginCommonLayout>
  )
}

export default InitSuccessPage
